import classNames from 'classnames';
import React from 'react';

import * as styles from './header-underlay.module.scss';

const HeaderUnderlay: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { isAlwaysVisible?: boolean }
> = ({ isAlwaysVisible = false, className, ...props }) => (
  <div
    {...props}
    className={classNames(styles.underlay, isAlwaysVisible && styles.alwaysVisible, className)}
  />
);

export default HeaderUnderlay;
